module.exports = __webpack_public_path__ + "img/logovuejs.abfee9e5.png";